import React, {FC} from 'react';

import {
  TeammateLicenseTypesEnum,
  TeammateModel,
} from '../../../../libs/shared/core/src/models/api/teammateModel';
import {TeamModel} from '../../../../libs/shared/core/src/models/api/teamModel';
import {buildTeammateDisplayName} from '../../../../libs/shared/core/src/models/helpers/teammateModelHelpers';
import {TeammateAvatar} from '../../../../libs/shared/ui/src/components/avatar/teammateAvatar';
import {
  SettingsSearchDropdownContent,
  SettingsSearchDropdownGenericIcon,
  SettingsSearchDropdownItem,
  SettingsSearchDropdownItemLeftIcon,
  SettingsSearchDropdownSubtitle,
  SettingsSearchDropdownTitle,
} from './settingsSearchCommon';
import {SettingsSearchDropdownItemBaseProps} from './settingsSearchCommonTypes';
import {SettingsSearchDropdownTeamAccessory} from './settingsSearchDropdownTeamAccessory';

/*
 * Props.
 */

interface SettingsSearchDropdownTeammateItemProps extends SettingsSearchDropdownItemBaseProps {
  teammate: TeammateModel;
  team?: TeamModel;
}

/*
 * Component.
 */

export const SettingsSearchDropdownTeammateItem: FC<SettingsSearchDropdownTeammateItemProps> = (props) => (
  <SettingsSearchDropdownItem
    checkmarkLabel={buildTeammateDisplayName(props.teammate)}
    onSelect={props.onSelect}
  >
    <SettingsSearchDropdownItemLeftIcon>{renderAvatar(props.teammate)}</SettingsSearchDropdownItemLeftIcon>
    <SettingsSearchDropdownContent>
      <SettingsSearchDropdownTitle>
        {buildTeammateDisplayName(props.teammate)}
        {props.team && <SettingsSearchDropdownTeamAccessory team={props.team} />}
      </SettingsSearchDropdownTitle>
      <SettingsSearchDropdownSubtitle>{props.teammate.email}</SettingsSearchDropdownSubtitle>
    </SettingsSearchDropdownContent>
  </SettingsSearchDropdownItem>
);

function renderAvatar(teammate: TeammateModel) {
  if (teammate.licenseType === TeammateLicenseTypesEnum.TEMPLATE) {
    return <SettingsSearchDropdownGenericIcon name="templateSmall" />;
  }

  return <TeammateAvatar size={32} teammate={teammate} />;
}
